import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { AuthService } from '../login/auth.service';
import {
  AddAnotherDescription,
  Brand,
  BrandBindings,
  BrandRatingQueueItem,
  BrandUpdateDto,
  MergeBrandsDto
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  getAllBrands() {
    return this.http.get<Brand[]>(`${environment.BACKEND}/brand/list`);
  }

  /** Бренды без рейтинга, отсортированные по продажам и попаданиям в подбор. */
  getRatingQueue(limit = 200) {
    return this.http.get<BrandRatingQueueItem[]>(`${environment.BACKEND}/brand/rating-queue`, {
      params: { limit }
    });
  }

  create(description: string, oe: boolean) {
    return this.http.post<Brand>(`${environment.BACKEND}/brand/create`, { description, oe });
  }

  update(payload: BrandUpdateDto) {
    return this.http.put<Brand>(`${environment.BACKEND}/brand/update`, payload);
  }

  getOne(id: number) {
    return this.http.get<Brand>(`${environment.BACKEND}/brand/${id}`);
  }

  getBindings(id: number) {
    return this.http.get<BrandBindings>(`${environment.BACKEND}/brand/${id}/bindings`);
  }

  addAnotherBrandDescription(payload: AddAnotherDescription) {
    return this.http.put<Brand>(`${environment.BACKEND}/brand/add_another_description`, payload);
  }

  removeAnotherBrandDescription(id: number) {
    return this.http.delete(`${environment.BACKEND}/brand/remove_another_description/${id}`);
  }

  merge(payload: MergeBrandsDto) {
    return this.http.post<Brand>(`${environment.BACKEND}/brand/merge`, payload);
  }
}
